<template>
    <v-dialog v-if="!no_data.includes(item)" v-model="dialog" max-width="500px" persistent>
        <v-card class="pa-3">
            <v-card-title>
                <h2 class="title">Disable Banner</h2>
            </v-card-title>

            <v-card-text class="mt-5">
                <div>
                    <v-layout class="wrap">
                        <v-alert
                                outlined
                                color="error"
                                icon="mdi-comment-question"
                        >
                            Are you sure you want to disable banner for {{ item.url }} ?
                        </v-alert>
                    </v-layout>
                    <v-alert class="pa-2 mt-3" :value="!serverValidation" outlined color="error" icon="mdi-alert"
                             transition="scale-transition">
                        <span class="caption">{{ serverValidationMessage }}</span>
                    </v-alert>
                </div>
            </v-card-text>

            <v-card-actions class="px-6">
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeDisableBanner">Cancel</v-btn>
                <v-btn
                        color="primary"
                        :disabled="loading"
                        :loading="loading"
                        @click="DisableBanner"
                >Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import ApiService from "@/common/api.service";

    export default {
        name: 'DisableBanner',
        data: () => ({
            no_data: [null, "", undefined, "null"],
            item: null,
            loading: false,
            dialog: false,
            serverValidation: true,
            serverValidationMessage: "Oops something went wrong...",
            server_errors: {}
        }),
        mounted() {
            this.$root.$on('DisableBanner', this.openModal)
        },
        beforeDestroy() {
            this.$root.$off('DisableBanner', this.openModal)
        },
        methods: {
            openModal(inputData) {
                this.resetServerValidation()
                this.item = inputData
                this.dialog = true
            },
            DisableBanner() {
                this.resetServerValidation()
                this.loading = true
                ApiService.put(`/banner/${this.item.id}/delete`)
                    .then(response => {
                        this.$root.$emit("notification", {
                            status: "success",
                            text: `Banner has been successfully disabled.`
                        });
                        this.loading = false
                        this.$emit('done')
                        this.closeDisableBanner()
                    })
                    .catch(({response}) => {
                        this.loading = false;
                        this.serverValidation = false;
                        if (response.data.error) {
                            this.serverValidationMessage = this.titleCase(
                                response.data.error
                            );
                        }
                        if (response.data.message) {
                            this.serverValidationMessage = response.data.message;
                        }
                        if (response.data.errors) {
                            this.server_errors = response.data.errors;
                        }
                    });
            },
            closeDisableBanner() {
                this.dialog = false
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            },
        }
    }
</script>
